import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";
export const GetVoidCards = async ({
  limit = DEFAULT_LIMIT,
  offset = 0,
  prn = "",
  created_by = "",
  office_id = "",
  dateFrom = "",
  dateTo = "",
}) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `card-issuing/void-cards?prn=${prn}&created_by=${created_by}&office_id=${office_id}&created_on_gte=${dateFrom}&created_on_lte=${dateTo}&limit=${limit}&offset=${offset}`,
    options
  );
};
